(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/result/result-chart.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/result/result-chart.js');

'use strict';

const HighchartsReact = svs.components.libs.ReactHighcharts;
const ResultChart = _ref => {
  let {
    title,
    data,
    barHeight = '400'
  } = _ref;
  const barColor = () => {
    if (svs.grassroots.tenant === 'sport') {
      return '#00BEFA';
    } else if (svs.grassroots.tenant === 'tur') {
      return '#00D773';
    }
    return '#FFD2D2';
  };
  const options = {
    title: {
      text: title,
      style: {
        color: '#001932'
      }
    },
    chart: {
      height: barHeight,
      marginRight: 30
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    navigation: {
      buttonOptions: {
        enabled: false
      }
    },
    xAxis: {
      type: 'category',
      categories: data.categories,
      labels: {
        align: 'left',
        reserveSpace: true,
        style: {
          color: '#001932',
          fontSize: '0.9em'
        }
      }
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        enabled: false
      }
    },
    plotOptions: {
      series: {
        color: barColor(),
        groupPadding: 0.05,
        pointPadding: 0.1,
        borderWidth: 0,
        type: 'bar',
        dataLabels: {
          crop: false,
          overflow: 'allow',
          enabled: true,
          formatter() {
            return "".concat(Highcharts.numberFormat(this.y, 0), " kr");
          },
          style: {
            fontWeight: 'normal',
            opacity: 1,
            color: '#001932',
            fontSize: '0.9em'
          }
        }
      }
    },
    tooltip: {
      valueDecimals: 0,
      valueSuffix: ' kr'
    },
    series: [{
      type: 'bar',
      name: 'Utbetalt',
      data: data.values
    }],
    responsive: {
      rules: [{
        condition: {
          maxWidth: 550
        },
        chartOptions: {
          chart: {
            marginRight: 80
          }
        }
      }]
    }
  };
  return React.createElement("div", {
    className: "highcharts-light"
  }, React.createElement(HighchartsReact
  , {
    highcharts: Highcharts,
    options: options
  }));
};
svs.grassroots.components.result.ResultChart = ResultChart;

 })(window);